import { createElement } from "react";
import { camelCaseMap } from "../../camelCasedAttributes.js";
import { useMemo } from "react";
import React from "react";
/**
 * Create a React style object from the inline style of a DOM node
 * @param domNode Dom node to map
 * @returns style object or undefined if there is no style
 */
function mapInlineStyleAsReactStyle(domNode) {
    if (!domNode.style)
        return undefined;
    const style = domNode.style;
    const result = {};
    for (let i = 0; i < style.length; i++) {
        let prop = style[i];
        if (style[prop]) {
            result[prop] = style[prop];
        }
    }
    if (Object.keys(result).length === 0)
        return undefined;
    return result;
}
/**
 * Extract all attributes from a DOM node and map them to React props
 * @param domNode DOM node to map
 * @returns React props
 */
export function mapAttributesAsReactProps(domNode) {
    const { attributes } = domNode;
    if (!attributes)
        return {};
    const props = {};
    for (let i = 0; i < attributes.length; i++) {
        const attribute = attributes.item(i);
        if (!attribute) {
            continue;
        }
        let key = attribute.name;
        let value = attribute.value;
        key = camelCaseMap[key.replace(/[-:]/, "")] || key;
        if (key === "style") {
            continue;
        }
        else if (key === "class") {
            continue;
        }
        else if (key === "for") {
            key = "htmlFor";
        }
        else if (key.startsWith("on")) {
            console.error("Event handlers are not supported yet in HTMLNode.", domNode);
            continue;
        }
        props[key] = value;
    }
    // Apply class names to props as well
    if (domNode.className) {
        props.className = domNode.className;
    }
    // Apply inline styles to props as well
    const inlineStyle = mapInlineStyleAsReactStyle(domNode);
    if (inlineStyle) {
        props.style = inlineStyle;
    }
    return props;
}
/**
 * ID counter to have unique keys for HTML nodes
 */
let htmlId = 0;
/**
 * Render an HTMLElement as a React element
 */
function MappedHTMLElement({ node }) {
    const { domNode: domNode } = node;
    const htmlElement = domNode;
    const attributes = useMemo(() => mapAttributesAsReactProps(htmlElement), [htmlElement]);
    const { tagName, id } = htmlElement;
    const key = useMemo(() => id !== null && id !== void 0 ? id : `smartfire-html-node-${htmlId++}`, [id]);
    return createElement(tagName.toLowerCase(), Object.assign(Object.assign({}, attributes), { key }), node.children && node.children.length > 0
        ? node.children.map((child) => child.asReactElement())
        : void 0);
}
/**
 * Render a DOM Node as a React element
 */
export function HTMLNode({ node }) {
    const { domNode: domNode } = node;
    if (domNode instanceof HTMLElement) {
        return React.createElement(MappedHTMLElement, { node: node });
    }
    else if (domNode instanceof Text) {
        return React.createElement(React.Fragment, null, domNode.textContent);
    }
    else {
        // Happens when the node is a comment, doctype, etc.
        // Those nodes are not rendered by React and are ignored
        return null;
    }
}

//# sourceMappingURL=HTMLNode.js.map
